import { useCallback, useEffect, useState } from 'react';
import { useAuthVerifier } from '~/domain/auth/hooks/use-auth-verifier';
import { useAuthChallenge } from '~/domain/auth/hooks/use-auth-challenge';
import { digestMessage } from '../utils/crypto';
import { composeLoginUrl, composeLogoutUrl } from '../utils/login-url';

const useLoginUrl = () => {
  const { verifierCode } = useAuthVerifier();
  const { challengeCode } = useAuthChallenge(String(verifierCode));
  const [loginUrl, setLoginUrl] = useState<string>('');
  useEffect(() => {
    if (challengeCode) {
      setLoginUrl(composeLoginUrl(challengeCode));
    }
  }, [challengeCode, verifierCode]);

  const getLogoutUrl = useCallback(async () => {
    const code = challengeCode ?? (await digestMessage(String(verifierCode)));
    return composeLogoutUrl(code);
  }, [challengeCode, verifierCode]);

  return { loginUrl, getLogoutUrl, verifierCode };
};

export { useLoginUrl };
